import * as React from "react";

import "react-international-phone/style.css";
import { Button } from "primereact/button";

import { useToast } from "../../../context/ToastContext";
import useApiService from "../../../hooks/useApiService";
import { DataTable } from "primereact/datatable";

import { Equipment } from "../../../models/equipment.interface";
import { useState } from "react";
import { Column } from "primereact/column";
import { CancelIcon, CheckIcon } from "../../../assets/icons";
import { formatCurrency } from "../../../utils/currenctUtils";
import { formatDate } from "../../../utils/DateUtils";

export default function SiteEquipmentAdd(modalProps: any) {
  const [equipmentData, setEquipmentData] = useState<Equipment[]>([]);
  const [selectedEquipment, setSelectedEquipment] = useState<Equipment[]>([]);
  const [rowClick, __] = useState(true);
  const toast = useToast();

  function handleSelectionChange(e: any) {
    setSelectedEquipment(e.value);
  }

  const { loading: loadingEquipment } = useApiService<Equipment[]>({
    method: "GET",
    url: "equipment",
    apiName: "core",
    onSuccess: data => {
      const availableEquipment = data.filter(
        equipment => !modalProps?.equipmentIds.includes(equipment.id)
      );
      setEquipmentData(availableEquipment);
    },
  });

  const { loading: addingEquipment, fetchData: addEquipment } = useApiService<
    {
      active: boolean;
      equipment: string;
      id: number;
      site: string;
    }[]
  >({
    fetchOnMount: false,
    url: "site-equipment",
    method: "POST",
    apiName: "core",
    onSuccess: data => {
      toast("success", "Equipment Added Successfully");
      modalProps.setReload?.(!modalProps.reload);
      modalProps.setVisible?.(false);
      if (modalProps.callback) modalProps.callback();
    },
    onError: error => {
      toast("error", error.message || "Error adding equipment");
    },
  });

  async function handleSave(selectedData: Equipment[]) {
    const payload: { equipment: string[] } = {
      equipment: selectedData.map(equipment => equipment.id),
    };
    await addEquipment({
      payload: payload,
    });
  }

  const renderActiveStatus = (row: Equipment) => {
    if (row.active) {
      return <CheckIcon fill={"#2DD36FFF"} />;
    }
    return <CancelIcon fill={"#EB445AFF"} />;
  };

  const renderPrice = (row: Equipment) => {
    return formatCurrency(row.price, true);
  };

  const renderMaintenanceDate = (row: Equipment) => {
    return formatDate(row.maintenance_start_date);
  };

  const renderExpectedLife = (row: Equipment) => {
    return `${row.expected_life_value ?? "—"} ${row.expected_life_interval ?? "—"}`;
  };

  return (
    <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, overflowY: "auto", padding: "0 1rem 1rem" }}>
        {/*@ts-ignore*/}
        <DataTable
          value={equipmentData ?? []}
          selectionMode={rowClick ? "multiple" : null}
          selection={selectedEquipment}
          onSelectionChange={(e: any) => {
            handleSelectionChange(e);
          }}
          dataKey={"id"}
          tableStyle={{ minWidth: "50rem" }}
          loading={loadingEquipment}
        >
          <Column selectionMode="multiple" headerStyle={{ width: "3rem" }}></Column>
          <Column header={"Name"} field={"name"} style={{ minWidth: "12rem" }} />
          <Column header={"Description"} field={"description"} />
          <Column header={"Type"} field={"type"} />
          <Column header={"Active"} field={"active"} body={renderActiveStatus} />
          <Column header={"Price"} field={"price"} body={renderPrice} />
          <Column header={"Serial Number"} field={"serial_number"} />
          <Column
            header={"Maintenance"}
            field={"next_maintenance_window"}
            body={renderMaintenanceDate}
          />
          <Column
            header={"Expected life"}
            field={"expected_life_value"}
            body={renderExpectedLife}
          />
        </DataTable>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          gap: "1rem",
          background: "white",
          paddingTop: "1rem",
          borderTop: "1px solid #e5e7eb",
          flexShrink: 0,
        }}
      >
        <Button
          label="Cancel"
          severity="secondary"
          outlined
          onClick={() => {
            modalProps.setVisible?.(false);
          }}
        />

        <Button
          label={"Add Equipment"}
          color={"primary"}
          loading={addingEquipment}
          disabled={addingEquipment || loadingEquipment}
          onClick={async () => {
            await handleSave(selectedEquipment);
          }}
        />
      </div>
    </div>
  );
}
